import { render, staticRenderFns } from "./free.vue?vue&type=template&id=f8d596ac&"
import script from "./free.vue?vue&type=script&lang=js&"
export * from "./free.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports